import { render, staticRenderFns } from "./goodsApply.vue?vue&type=template&id=1764efc8&scoped=true&"
import script from "./goodsApply.vue?vue&type=script&lang=js&"
export * from "./goodsApply.vue?vue&type=script&lang=js&"
import style0 from "./goodsApply.vue?vue&type=style&index=0&id=1764efc8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1764efc8",
  null
  
)

export default component.exports